export class CRMOportunidadeAnexo {
  id: number;
  idOportunidade: number;
  idAnexo: number;
  descricao: string;
  arquivo: string;
  visualizavel: boolean;
  usuario?: number;
  nomeUsuario?: string;
  dataHora?: Date;
  statusExc: boolean;
  dataHoraExc?: Date;
  nomeUsuarioExc?: string;
}
